import React from "react";
import { Link } from "react-router-dom";
import { Cherry, Cog, HeartPulse, House, MessageSquareDot, TicketCheck } from "lucide-react";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import Diversity1OutlinedIcon from "@mui/icons-material/Diversity1Outlined";

const DesktopSidebarDashboardButtons = () => {
  const sidebarButtons = [
    {
      name: "Home",
      icon: <House />,
      link: "/home",
    },
    {
      name: "My Health Report",
      icon: <HeartPulse />,
      link: "/health-report",
    },
    {
      name: "My Counselling",
      icon: <Diversity1OutlinedIcon />,
      link: "/counselling",
    },
    {
      name: "My Subscriptions",
      icon: <TicketCheck />,
      link: "/my-subscriptions",
    },
    {
      name: "My Nutrients",
      icon: <Cherry />,
      link: "https://supple.nhwm.in/",
    },
    {
      name: "Explore Plans",
      icon: <HealthAndSafetyIcon />,
      link: "/plans",
    },
    {
      name: "Notifications",
      icon: <MessageSquareDot />,
      link: "/notification",
    },
    {
      name: "My Account",
      icon: <Cog />,
      link: "/account-settings",
    },
  ];

  return (
    <>
      {sidebarButtons?.map((button) =>
        button.name === "My Nutrients" ? (
          <a href={button.link} key={button.name} target="_blank" rel="noopener noreferrer">
            <div
              className={`rounded-full px-4 text-sm py-2 transition-all duration-500 ease-in-out ${
                window.location.pathname === button.link
                  ? "bg-[#274760] "
                  : "hover:bg-[#307bc4]/50"
              }`}
            >
              <h5
                className={`flex gap-2 my-1 ${
                  window.location.pathname === button.link
                    ? "text-white text-md font-normal"
                    : "font-normal"
                }`}
              >
                {button.icon} {button.name}
              </h5>
            </div>
          </a>
        ) : (
          <Link to={button.link} key={button.name}>
            <div
              className={`rounded-full px-4 text-sm py-2 font-normal transition-all duration-500 ease-in-out ${
                window.location.pathname === button.link
                  ? "bg-[#274760] "
                  : "hover:bg-[#307bc4]/50"
              }`}
            >
              <h5
                className={`flex gap-2 my-1 ${
                  window.location.pathname === button.link
                    ? "text-white text-md font-normal"
                    : "font-normal"
                }`}
              >
                {button.icon} {button.name}
              </h5>
            </div>
          </Link>
        ),
      )}
    </>
  );
};

export default DesktopSidebarDashboardButtons;
